import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitotelanganacabservice() {



const cardData = {
  keyword: " Mumbai to Telangana Cab Service",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Telangana cab services for travelers planning long-distance trips between Maharashtra and Telangana. Whether you are traveling to Hyderabad or other cities in Telangana for business, family visits, tourism, or pilgrimage, our cab service ensures a smooth and safe journey with experienced drivers and well-maintained vehicles. The road distance between Mumbai and Hyderabad, the capital of Telangana, is around 700–720 km depending on the route, making private cab travel a convenient option for flexible and comfortable journeys. We provide multiple booking options including one-way cab service, round-trip packages, and multi-day travel plans with transparent per-kilometer pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual pickup from anywhere in Mumbai, skilled chauffeurs experienced in long-distance highway driving, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Telangana cab booking.",

topPlaces: [
  {
    title: "Charminar (Hyderabad)",
    description:
      "Charminar is the most iconic monument of Hyderabad and one of the most visited tourist attractions in Telangana. Built in the late 16th century, this historic structure features four grand minarets and beautiful Indo-Islamic architecture that reflects the city’s heritage. Visitors explore the surrounding Laad Bazaar for traditional bangles, jewelry, and street food while enjoying the vibrant atmosphere of the old city. Traveling by cab from Mumbai allows tourists to comfortably reach Hyderabad and explore Charminar along with nearby heritage sites and markets at their own pace."
  },
  {
    title: "Golconda Fort",
    description:
      "Golconda Fort is a historic hilltop fortress known for its impressive architecture, acoustic design, and panoramic views of Hyderabad city. The fort complex includes royal palaces, ancient gateways, and ramparts that showcase the engineering brilliance of past dynasties. Visitors can climb to the top for spectacular city views or attend the evening sound and light show that narrates the history of the fort. A cab journey from Mumbai to Telangana provides a convenient way to explore this historic landmark without worrying about local transportation."
  },
  {
    title: "Ramoji Film City",
    description:
      "Ramoji Film City is one of the largest film studio complexes in the world and a major tourist attraction near Hyderabad. Spread across thousands of acres, it features film sets, gardens, theme parks, entertainment shows, and guided studio tours. Families, movie lovers, and tourists enjoy exploring movie sets, live performances, and themed attractions throughout the day. Traveling by cab from Mumbai to Telangana allows visitors to plan a comfortable trip and spend an entire day experiencing this unique entertainment destination."
  },
  {
    title: "Hussain Sagar Lake",
    description:
      "Hussain Sagar Lake is a large artificial lake located between Hyderabad and Secunderabad and is famous for the massive Buddha statue standing in the middle of the water. Visitors can enjoy boating, lakeside walks, and beautiful sunset views from nearby parks such as Lumbini Park and NTR Gardens. The lake area is also a popular place for evening outings, photography, and relaxation. A cab service makes it easy for travelers to visit this scenic attraction and explore nearby sightseeing spots comfortably."
  },
  {
    title: "Birla Mandir Hyderabad",
    description:
      "Birla Mandir is a magnificent temple dedicated to Lord Venkateswara and is built entirely with white marble on a hill overlooking Hyderabad city. The temple offers a peaceful spiritual atmosphere and panoramic views of Hussain Sagar Lake and the surrounding skyline. Visitors often come here for prayers, meditation, and photography during sunrise or sunset. Traveling by cab allows visitors to easily reach the hilltop temple and enjoy a calm spiritual experience during their Telangana trip."
  },
  {
    title: "Salar Jung Museum",
    description:
      "Salar Jung Museum is one of the largest museums in India and houses an extensive collection of art, antiques, sculptures, manuscripts, and historical artifacts from around the world. The museum’s famous exhibits include rare paintings, decorative objects, and unique sculptures collected over decades by the Salar Jung family. History lovers often spend hours exploring its galleries and learning about different cultures and civilizations. A cab ride allows tourists to comfortably include this cultural landmark in their Hyderabad sightseeing itinerary."
  },
  {
    title: "Mecca Masjid",
    description:
      "Mecca Masjid is one of the largest and oldest mosques in India, located close to Charminar in the historic part of Hyderabad. The mosque is known for its grand architecture, massive courtyard, and peaceful spiritual environment. Visitors often admire the historic design and observe the daily prayers that attract devotees from across the region. A comfortable cab journey from Mumbai makes it convenient for travelers to explore this important religious and historical site."
  },
  {
    title: "Nehru Zoological Park",
    description:
      "Nehru Zoological Park is a popular wildlife attraction in Hyderabad spread across a vast area with numerous animal enclosures, safari rides, and green landscapes. The zoo is home to a wide range of species including lions, tigers, elephants, reptiles, and birds, making it a favorite destination for families and nature lovers. Visitors can also enjoy toy train rides and educational exhibits inside the park. Traveling by cab ensures convenient access to this family-friendly destination during your Telangana visit."
  },
  {
    title: "Chowmahalla Palace",
    description:
      "Chowmahalla Palace is a historic royal residence of the Nizams of Hyderabad and is known for its elegant courtyards, grand halls, and beautiful architecture. The palace complex displays royal artifacts, vintage cars, and historical items that reflect the lifestyle of the Nizam rulers. Visitors enjoy exploring the palace gardens, photography spots, and heritage exhibits. A cab service allows travelers to include this historic palace in their Hyderabad sightseeing tour comfortably."
  },
  {
    title: "Shilparamam Cultural Village",
    description:
      "Shilparamam is a cultural arts and crafts village located in Hyderabad that promotes traditional Indian handicrafts and cultural heritage. The village hosts craft exhibitions, cultural performances, and handicraft markets where visitors can buy handmade items from artisans. Travelers enjoy exploring traditional art forms, local cuisine stalls, and cultural festivals held throughout the year. Traveling by cab from Mumbai to Telangana allows tourists to comfortably visit this vibrant cultural attraction during their Hyderabad trip."
  }
],



services: [
{
name: "Mumbai to Telangana Cab",
description: "Mumbai to Telangana cab service offers reliable long-distance transportation for travelers visiting major cities across the state of Telangana. The route connects Mumbai with cities like Hyderabad, Warangal, Karimnagar, and Nizamabad through well-maintained national highways. Professional drivers ensure safe driving and punctual pickup services from homes, hotels, offices, railway stations, and airport terminals across Mumbai. Vehicles are well maintained and suitable for interstate highway travel. Spacious seating and luggage capacity ensure comfortable journeys for families and groups. Ideal for business trips, family visits, and tourism travel. Flexible booking options allow convenient ride scheduling and travel planning."
},
{
name: "Mumbai to Telangana Taxi",
description: "Mumbai to Telangana taxi service provides comfortable and dependable transportation for long-distance travel between Maharashtra and Telangana. Vehicles are designed for extended highway journeys and provide smooth driving performance with spacious seating. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for tourism visits, family trips, and corporate travel to Telangana cities. Air-conditioned vehicles ensure relaxed travel throughout the journey. Flexible taxi booking options allow passengers to easily plan and reserve rides."
},
{
name: "Mumbai to Telangana Cab Service",
description: "Mumbai to Telangana cab service offers dependable interstate travel for passengers visiting different cities across Telangana. Vehicles provide comfortable seating and reliable highway performance suitable for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism travel, family visits, and corporate trips. Comfortable interiors ensure relaxed journeys throughout the trip. Flexible booking options allow passengers to schedule rides conveniently."
},
{
name: "Mumbai to Telangana Taxi Service",
description: "Mumbai to Telangana taxi service provides convenient transportation for travelers visiting Telangana for tourism, business, or family purposes. Vehicles are suitable for interstate highway travel and provide smooth ride performance and spacious seating. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airports. Ideal for long-distance journeys and tourism travel. Air-conditioned vehicles ensure comfortable travel experiences. Flexible taxi booking options allow passengers to easily plan their travel."
},
{
name: "Mumbai to Hyderabad Cab",
description: "Mumbai to Hyderabad cab service offers reliable transportation between the financial capital of Maharashtra and the major IT city of Hyderabad. The route is commonly used for corporate travel, tourism, and family visits. Vehicles provide comfortable seating and smooth highway performance for long-distance journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for business travel, tourism trips, and family journeys. Flexible booking options allow convenient travel planning."
},
{
name: "Mumbai to Warangal Cab",
description: "Mumbai to Warangal cab service provides comfortable long-distance transportation for travelers visiting the historic city of Warangal in Telangana. Vehicles are suitable for interstate travel and provide spacious seating for extended highway journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for tourism travel, family visits, and business trips. Air-conditioned vehicles ensure relaxed travel experiences. Flexible booking options allow easy cab reservations."
},
{
name: "Mumbai to Karimnagar Cab",
description: "Mumbai to Karimnagar cab service offers dependable transportation for travelers visiting the important Telangana city of Karimnagar. Vehicles provide smooth highway performance and comfortable seating for long-distance travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family visits, tourism travel, and corporate journeys. Comfortable vehicles ensure relaxed travel experiences. Flexible booking options allow passengers to easily schedule rides."
},
{
name: "Mumbai to Nizamabad Cab",
description: "Mumbai to Nizamabad cab service provides convenient interstate transportation for passengers traveling to the Telangana city of Nizamabad. Vehicles are suitable for long-distance highway journeys and provide spacious seating for passengers and luggage. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism travel, family visits, and corporate journeys. Air-conditioned vehicles ensure comfortable travel experiences. Flexible booking options allow convenient ride reservations."
},
{
name: "Mumbai to Khammam Cab",
description: "Mumbai to Khammam cab service offers reliable long-distance travel for passengers visiting Khammam city in Telangana. Vehicles provide smooth highway performance and comfortable seating suitable for extended journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for tourism travel, family visits, and business trips. Comfortable interiors ensure relaxed journeys. Flexible booking options allow passengers to easily plan their travel."
},
{
name: "Mumbai to Telangana Taxi Fare",
description: "Mumbai to Telangana taxi fare options provide transparent pricing based on vehicle type, travel distance, and trip duration. Travelers can choose sedan, SUV, or MPV vehicles depending on comfort preferences and group size. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for long-distance travel, tourism visits, and corporate trips. Comfortable vehicles ensure relaxed journeys. Transparent fare structure allows easy budgeting and travel planning."
},
{
name: "Mumbai to Telangana One Way Cab",
description: "Mumbai to Telangana one way cab service offers economical intercity travel without return charges. Vehicles provide comfortable seating and smooth highway performance suitable for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for travelers relocating, business trips, and tourism journeys. Air-conditioned vehicles ensure comfortable travel experiences. Flexible booking options allow quick and convenient ride reservations."
},
{
name: "Mumbai to Telangana Round Trip Taxi",
description: "Mumbai to Telangana round trip taxi service provides convenient transportation for travelers planning return journeys between Mumbai and Telangana cities. Vehicles are suitable for long-distance highway travel and multi-day trips. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family visits, tourism travel, and corporate journeys. Comfortable interiors ensure relaxed journeys throughout the trip. Flexible round-trip packages allow convenient travel planning."
},
{
name: "Mumbai to Telangana Innova Cab",
description: "Mumbai to Telangana Innova cab service provides spacious MPV transportation suitable for family and group travel. The Toyota Innova offers comfortable seating, large luggage capacity, and smooth highway stability for long-distance interstate journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism travel, family trips, and corporate journeys. Comfortable interiors ensure relaxed travel experiences. Flexible booking options allow convenient ride scheduling."
},
{
name: "Mumbai to Telangana Ertiga Cab",
description: "Mumbai to Telangana Ertiga cab service offers comfortable MPV transportation suitable for small families and groups traveling long distances. The Maruti Ertiga provides spacious seating and smooth ride quality for interstate highway travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism travel, family visits, and business trips. Air-conditioned interiors ensure comfortable journeys. Flexible booking options allow easy ride reservations."
},
{
name: "Mumbai to Telangana Sedan Cab",
description: "Mumbai to Telangana sedan cab service provides economical and comfortable transportation for long-distance travel between Mumbai and Telangana cities. Sedan vehicles offer smooth ride performance and comfortable seating for small families or business travelers. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for corporate travel, tourism journeys, and family visits. Air-conditioned sedans ensure comfortable travel experiences. Flexible booking options allow convenient ride scheduling."
}
],

tableData: [
["Mumbai to Telangana Cab","Mumbai to Telangana Taxi"],
["Mumbai to Telangana Cab Service","Mumbai to Telangana Taxi Service"],
["Mumbai to Hyderabad Cab","Mumbai to Warangal Cab"],
["Mumbai to Karimnagar Cab","Mumbai to Nizamabad Cab"],
["Mumbai to Khammam Cab","Mumbai to Telangana Taxi Fare"],
["Mumbai to Telangana One Way Cab","Mumbai to Telangana Round Trip Taxi"],
["Mumbai to Telangana Innova Cab","Mumbai to Telangana Ertiga Cab"],
["Mumbai to Telangana Sedan Cab","Telangana Tour Cab from Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Interstate Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance interstate travel from Mumbai to Telangana. They are familiar with major highways and routes connecting cities like Hyderabad, Warangal, Karimnagar, and Nizamabad, ensuring a safe and comfortable journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Mumbai to Telangana cab services. Customers receive complete information about per-kilometer charges, toll costs, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Service",
    WhyChoosedescription: "Our Mumbai to Telangana cab service operates 24 hours a day. Whether you want to start early morning or travel overnight, we provide reliable cab booking anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, regularly cleaned, and fully air-conditioned to ensure passengers enjoy a comfortable long-distance journey."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Packages",
    WhyChoosedescription: "We offer flexible travel options including one-way cab booking, round trips, and multi-day travel packages from Mumbai to Telangana cities."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers various vehicles including sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers suitable for families and groups."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your Telangana journey begins smoothly."
  },
  {
    WhyChooseheading: "Reliable Long-Distance Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by travelers for reliable interstate taxi services. Our punctual drivers, comfortable vehicles, and professional service ensure a stress-free journey from Mumbai to Telangana."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Mumbai to Telangana?", answer: "Yes, Omshree Cabs provides reliable cab services from Mumbai to Telangana including cities like Hyderabad, Warangal, and Karimnagar." },
  { question: "Can I book a one-way cab from Mumbai to Telangana?", answer: "Yes, we offer both one-way and round-trip cab services for travel between Mumbai and Telangana." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on group size." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our Mumbai to Telangana cab service operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "How long does the journey from Mumbai to Telangana take?", answer: "Travel time depends on the destination city in Telangana, but it typically takes around 12 to 15 hours by road." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, rest, or sightseeing." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially for long-distance interstate travel." },
  { question: "Do you provide pickup from Mumbai Airport?", answer: "Yes, we provide pickup from Mumbai Airport for travelers heading to Telangana." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Pradeep Reddy",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Hyderabad trip. The vehicle was comfortable and the driver handled the long journey very professionally.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Sharma",
    feedback:
      "Excellent long-distance cab service. Smooth travel from Mumbai to Telangana with a clean vehicle and reliable driver.",
    rating: 5
  }
];











































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Telangana Cab Service",
  "description": "Omshree Cab offers reliable cab services from Mumbai to Telangana, covering Hyderabad, Warangal, Karimnagar, Nizamabad, Khammam, and other destinations. Travel comfortably with Innova, Ertiga, Sedan, and other vehicles for one-way or round trips. Enjoy safe, punctual, and convenient journeys with flexible booking options and transparent pricing.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "980"
  }
};









  return (
    <div>
      <Helmet>
  <title>Mumbai to Telangana Cab Service | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides cab services from Mumbai to Telangana, including Hyderabad, Warangal, Karimnagar, Nizamabad, and Khammam. Travel with Innova, Ertiga, and Sedan vehicles. Safe, punctual, and convenient journeys with flexible booking options and transparent pricing." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/65.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitotelanganacabservice;